'use strict';

export {default as Calculator} from './classes/Calculator';

import config from '../../bower.json';
import calculator from './components/calculator'

Vue.component(config.name, calculator);


// WEBPACK FOOTER //
// ./src/js/index.js